import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG, PERFORMANCE_OFFERINGS } from "@/data/site";
import { ButtonLink, Eyebrow, FadeIn } from "@/components/blocks";

export default function PerformanceBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="performance-band" className="relative overflow-hidden bg-ink">
      <motion.div style={{ y }} className="absolute inset-0 -top-[15%] h-[130%]">
        <img
          src={IMG.jump}
          alt="Athlete mid-air during performance training"
          loading="lazy"
          className="h-full w-full object-cover opacity-45"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/70 to-ink/30" />

      <div className="relative z-10 mx-auto max-w-[1440px] px-6 py-32 sm:px-10 sm:py-44 lg:px-16">
        <FadeIn>
          <Eyebrow>Performance / HYROX</Eyebrow>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 max-w-5xl font-display text-4xl font-black uppercase leading-[0.92] tracking-tight text-bone sm:text-6xl lg:text-8xl">
            Train for more than the <span className="text-lime">finish line.</span>
          </h2>
        </FadeIn>
        <FadeIn delay={0.2}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-bone/75 sm:text-lg">
            StrengthLeap performance coaching combines strength, conditioning, race preparation, recovery and
            movement quality — coached live, on camera, in every session.
          </p>
        </FadeIn>

        <div className="mt-14 grid max-w-3xl gap-x-12 gap-y-4 sm:grid-cols-2">
          {PERFORMANCE_OFFERINGS.map((o, i) => (
            <FadeIn key={o} delay={0.15 + i * 0.06}>
              <p className="flex items-center gap-4 border-t border-bone/15 py-4 font-mono text-[11px] uppercase tracking-[0.22em] text-bone/85 sm:text-xs">
                <span className="text-lime">{String(i + 1).padStart(2, "0")}</span>
                {o}
              </p>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={0.3} className="mt-14">
          <ButtonLink to="/performance" variant="lime" testid="performance-band-cta">
            Explore Performance Coaching
          </ButtonLink>
        </FadeIn>
      </div>
    </section>
  );
}
